<template>
  <div id="step-3-alt" class="multi-step-form active-step">
    <div class="d-flex align-content-center">
      <p style="margin-top:30px;">
        <img
         v-if="prevAtivo"
          src="@/assets/arrow-left.svg"
          alt="OK"
          @click="prevEtapa('step-2')"
        />
      </p>
    </div>
    <div
      class="d-flex align-content-center align-flex-title"
      style="margin-top: -55px"
    >
      <p>Vamos iniciar a simulação do seu plano de saúde?</p>
    </div>
    <div class="align-flex-title">
      <h3>Selecione o seu convênio</h3>
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
    >
      <!-- <template v-if="options_orgaos != undefined || options_orgaos != null">
        <autocomplete
          :source="selected_org_ent"
          :showNoResults="false"
          placeholder="Digite ou selecione aqui o seu Convênio"
          inputClass="form-control"
          :initialValue="null"
          resultsValue="name"
          @selected="getsubfat"
          :class="{
            'statusok-fontbold-autocomplete': selected_orgao != 'null',
          }"
        >
        </autocomplete>
      </template> -->

      <b-form-select 
        v-model="selected_orgao"
        @change="getsubfat()"
        :options="options_orgaos.descricao"
      >
        <b-form-select-option :value="null">
          Selecione aqui o seu Convênio
        </b-form-select-option>
        <b-form-select-option
          Class="form-control" 
          v-for="item in selected_org_ent" 
          :key="item.grupoCobranca"
          :value="item"
        >
          {{item.descricao}} - {{item.nomeCompleto}}
        </b-form-select-option>
      </b-form-select>
    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
      v-if="orgaoSubFat.length > 0"
    >

    <b-form-select
      v-model="selected_subfat"
      @change="getFaixa()"
      >
        <b-form-select-option 
          :value="null"
        >
          Selecione aqui o seu Sub Convênio
        </b-form-select-option>
        <b-form-select-option
          Class="form-control" 
          v-for="item in orgaoSubFat" 
          :key="item.ZZ2_CODIGO"
          :value="item"
        >
          {{item.ZZ2_DESCRI}}
        </b-form-select-option>
      </b-form-select>


    </div>
    <div
      class="row input-field-simulador"
      style="display: block; text-align: left"
      v-if="options_faixaremuneracao.length > 0"
    >
      <p>Qual sua faixa de remuneração?</p>
      <b-form-select
        v-model="selected_faixa"
        :options="options_faixaremuneracao"
        @change="setEtapa()"
        :class="{ 'statusok-fontbold': selected_faixa != 'null' }"
        :style="[
          selected_faixa != 'null'
            ? {
                background:
                  'url(' +
                  require('@/assets/statusok.svg') +
                  ') no-repeat right 2.6% center #ffffff',
              }
            : '',
        ]"
      >
        <b-form-select-option :value="null">
          Selecione aqui a sua Faixa
        </b-form-select-option>
      </b-form-select>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div v-if="errors.length">
      <b v-for="erro in errors" :key="erro">{{ erro }}</b>
    </div>
    <!-- TESTE VALIDAÇÃO -->
  </div>
</template>

<script>
import store from "@/store";
import lerauxilioService from "@/services/lerAuxilioSaude";
import axios from "axios";

export default {
  name: "StepTresAlt",
  data() {
    return {
      errors: [],
      prevAtivo: '',
      grupoSubfat: null,
      selected_subfat: null,
      orgaoSubFat: '',
    };
  },
  computed: {
    estadoid() {
      return store.getters.getAliancaEstadoID;
    },
    etapa: {
      get() {
        return store.getters.getAliancaProxEtapa;
      },
      set(newVal) {
        store.commit("mutAliancaProxEtapa", newVal);
      },
    },
    selected_orgao: {
      get() {
        return store.getters.getSimuleAquiSelectedOrgao;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedOrgao", newVal);
      },
    },
    selected_org_ent: {
      get() {
        return store.getters.getAliancaOrgEnt;
      },
      set(newVal) {
        store.commit("mutAliancaOrgEnt", newVal);
      },
    },
    selected_orgao_cod: {
      get() {
        return store.getters.getSimuleAquiSelectedOrgaoCod;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedOrgaoCod", newVal);
      },
    },
    options_orgaos: {
      get() {
        return store.getters.getSimuleAquiOrgaos;
      },
      set(newVal) {
        store.commit("mutSimuleAquiOrgaos", newVal);
      },
    },
    selected_faixa: {
      get() {
        return store.getters.getSimuleAquiSelectedFaixa;
      },
      set(newVal) {
        store.commit("mutSimuleAquiSelectedFaixa", newVal);
      },
    },
    options_faixaremuneracao: {
      get() {
        return store.getters.getSimuleAquiFaixaRemuneracao;
      },
      set(newVal) {
        store.commit("mutSimuleAquiFaixaRemuneracao", newVal);
      },
    },
    tipoorgaoentidade: {
      get() {
        return store.getters.getSimuleAquiTipoOrgaoEntidade;
      },
      set(newVal) {
        store.commit("mutSimuleAquiTipoOrgaoEntidade", newVal);
      },
    },
    orgao() {
      return store.getters.getAliancaFuncPub === "Sim";
    },
  },
  mounted() {
    document.getElementById("step-progress").value = 6.67 * 2;
    this.resetProcess();
    this.verificaEnv();
    this.ordemOrgEnt();
  },
  methods: {
    ordemOrgEnt(){
     this.ordemOrgaogEnt = this.selected_org_ent
    },
    async getsubfat(){
      const valor = []
      const subfatura = this.selected_orgao.subFaturas;

      subfatura.reduce(( acc, curr ) => {
        if (curr != '    ') {
          valor.push(curr)
        }
          return valor.join(',')
      });

      this.grupoSubfat = valor
      if (this.grupoSubfat == '') {
        this.grupoSubfat = '';
        this.orgaoSubFat = '';
        this.getFaixa()
      }else{
        this.buscarSubFat();
      }
    },
    async buscarSubFat(){
      try {
        // this.selected_orgao = '';
    
        const body ={
           convenio: this.selected_orgao.grupoCobranca,
           subfatura: this.grupoSubfat
        }
        await axios.post(process.env.VUE_APP_ALIANCAADM + `/alianca/orgao-e-entidade/buscaSubEntidades?api-key=` + process.env.VUE_APP_ALIANCAADM_ORGAO_ENTIDADE_API_KEY, body)
        .then(response =>{
          // this.orgaoSubFat = response.data
          this.orgaoSubFat = response.data.sort((a, b) => {
            let result = 0;

            if (a.ZZ2_DESCRI > b.ZZ2_DESCRI) {
              result = 1;
            } else {
              result = -1;
            }

            return result;
          });
        })
        .catch(error => {
          this.orgaoSubFat = undefined
          console.log(error)
        })
      } catch (e) {
        console.log(e)
      }
    },
    async validaSubFat(){
      if(this.selected_orgao.tipoorgaoentidade == "2"){
        this.orgaoSubFat = ''
        this.getOrgaoEntidadeData();
      }else{
        this.getFaixa()
      }

    },
    // verificaEnv(){
    //   console.log("env", process.env.NODE_ENV)
    //    if (process.env.NODE_ENV === "production" ) {
    //       this.prevAtivo = false;
    //    }else{
    //     this.prevAtivo = true;
    //    }
    // },
    // verificaEnv(){
    //   console.log("env", process.env.NODE_ENV)
    //    if (process.env.NODE_ENV === "production" ) {
    //       this.prevAtivo = false;
    //    }else{
    //     this.prevAtivo = true;
    //    }
    // },
    prevEtapa() {
      store.commit("mutAliancaProxEtapa", "step-1");
    },
    async getFaixa() {
      store.commit("mutSimuleAquiLoader", true);

      this.options_faixaremuneracao = [];

      await this.getOrgaoEntidadeData();
      // const selectedOrgaoEntidade = await buscarEntidadeOrgaoAPI(group.id);

      if (this.selected_orgao.tipoorgaoentidade == "2") {
        console.log('selected_orgao.tipoorgaoentidade')
        store.commit("mutAliancaFuncPub", "Não");
        this.setEtapa();
        return;
      } else {
        var bodyAuxilio = '';
        if (this.grupoSubfat == '') {
          this.grupoSubfat = '';
          this.orgaoSubFat = '';
          bodyAuxilio = {
            "codConvenio": this.selected_orgao.grupoCobranca,
            "codSubFat": "",
            "tipoAcesso": "3"
          }
        }else{
          bodyAuxilio = {
            "codConvenio": this.selected_subfat.ZZ2_GRPCOB,
            "codSubFat": this.selected_subfat.ZZ2_CODIGO,
            "tipoAcesso": "3"
          }
        }

        this.resultAuxilio = await lerauxilioService(bodyAuxilio)
        console.log('resultAuxilio', this.resultAuxilio)

        if(this.resultAuxilio == ''){
          store.commit("mutAliancaFuncPub", "Não");
          this.setEtapa();
        }else{
          store.commit("mutAliancaFuncPub", "Sim");
        }

      }

      store.commit("mutSimuleAquiSelectedProfissao", "");

      await this.getFaixaRemuneracao();

      store.dispatch("disAliancaEntidadeInfo");

      store.commit("mutSimuleAquiLoader", false);
    },
    async getFaixaRemuneracao() {
      await store.dispatch("disAliancaGetListaAuxilio");
      this.options_faixaremuneracao =
        store.getters.getAliancaListaFaixaRemuneracao;
    },
    async getOrgaoEntidadeData() {

      if (this.grupoSubfat.length > 0){
        const selectedOrgaoEntidade = this.selected_subfat;
        console.log('entrou em grupoSubfat')
        if (
          selectedOrgaoEntidade.ZZ2_GRPCOB ||
          selectedOrgaoEntidade.ZZ2_CODIGO
        )   {
          store.commit(
            "mutAliancaNumeroContrato",
            selectedOrgaoEntidade.ZZ2_GRPCOB
          );
          store.commit(
            "mutAliancaSubFatura",
            selectedOrgaoEntidade.ZZ2_CODIGO
          );
        }
      }else{
        const selectedOrgaoEntidade = this.selected_orgao;
        if (
          selectedOrgaoEntidade.grupoCobranca
        )   {
          store.commit(
            "mutAliancaNumeroContrato",
            selectedOrgaoEntidade.grupoCobranca
          );
          store.commit(
            "mutAliancaSubFatura",
            ''
          );
        }
      }
      
      this.tipoorgaoentidade = "orgao";

      // store.commit("mutAliancaEntidadeClasse", this.selected_entidade);

      store.dispatch("disAliancaOperadorasConvenio");
    },
    validaStep() {
      this.errors = [];

      if (this.selected_orgao == null) {
        this.errors.push("Selecione um orgão público válido");
        return false;
      }

      if (this.selected_faixa == null && this.orgao) {
        this.errors.push("Selecione uma faixa de remuneração válida");
        return false;
      }

      return true;
    },
    setEtapa() {
      if (!this.validaStep()) {
        return;
      }

      const objFaixa = this.options_faixaremuneracao.find(item => item.value === this.selected_faixa);

      // console.log("objFaixa", objFaixa);
      store.commit("mutAliancaFaixaRemuneracaoSelecionada", objFaixa);
      store.commit("mutAliancaOrgaoPub", this.selected_orgao);

      if (this.orgao)
        console.log('orgao aqui', this.orgao)
        store.commit("mutAliancaFaixaRemuneracao", {
          minimo: this.selected_faixa.split("-")[0],
          maximo: this.selected_faixa.split("-")[1],
        });

      this.etapa = "step-4";

      store.commit("mutSimuleAquiLoader", true);
    },
    resetProcess() {
      store.commit("mutSimuleAquiProfissoes", []);
      store.commit("mutSimuleAquiFaixaRemuneracao", []);

      store.commit("mutSimuleAquiSelectedOrgao", "null");
      store.commit("mutSimuleAquiSelectedEntidade", "null");
      store.commit("mutSimuleAquiSelectedProfissao", "null");
      store.commit("mutSimuleAquiSelectedFaixa", "null");
    },
  },
};
</script>